import $ from 'jquery';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import service from '../../services/allservices.jsx';
import '../../stylesheet/faqs.css';
import AuthNavbar from '../navigation/authnavigation.jsx'
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';
const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display
})

const mapDispatchToProps = dispatch =>
({
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
})

class WalletTerms extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ViewQnA: [],
            toggleType: "password",
            toggleText: "password",
            toggleIcon: "fa fa-eye-slash",
            togglePassIcon: "fa fa-eye-slash",
            open: true,
            viewStatus: null,
            loader: true,
        }
    }
    async componentDidMount() {

        $('.panel-collapse').on('show.bs.collapse', function () {
            $(this).siblings('.panel-heading').addClass('active');
        });

        $('.panel-collapse').on('hide.bs.collapse', function () {
            $(this).siblings('.panel-heading').removeClass('active');
        });
        const JSEncrypt = window.JSEncrypt
        const { publicKey } = this.props
        if (publicKey.status === 200) {
            const public_Key = publicKey.body.publickey;
            let encrypt = new JSEncrypt();
            encrypt.setPublicKey(public_Key);

            const state = {
                applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                accountId: encrypt.encrypt(localStorage.getItem("accountId"))
            }
            this.props.fetchCard(state)
        }
        this.setState({
            selectedCard: this.props.cardState.body,
        }, () => {

            let _this = this

let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ

  let traceId = getClientId();   
  let gid = getClientId()
            fetch(plink + service.ViewWalletTC + _this.state.selectedCard[0].programId, {
                headers: new Headers({
                    'Content-Type': 'application/json',
                     'X-Trace-Id': traceId,
                       'clientId': gid,
                    'clientSecret': getClientSecret(gid, _this.state.selectedCard[0].programId),
                    'X-KlickEx-Client':buildClientHeader(),
                    // 'Authorization': `Token ${localStorage.getItem('token')}`,
                    // 'clientId': localStorage.getItem('clientId'),
                    // 'clientSecret': localStorage.getItem('secretId'),
                }),

            })
                .then(response => {
                    if (response.status === 200) {
                        let message = response.message ? response.message : response.headers.get('message')
                        // toast.success( message , {
                        //     position: 'top-right',
                        //     autoClose: 3000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     draggablePercent: 60
                        // })
                        response.json().then(json => {
                            this.setState({
                                ViewQnA: json,
                                viewStatus: 200,
                            })
                        })
                    }
                    else if (response.status === 422) {
                        toast.error(response.headers.get('message'), {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        })
                    }
                    else if (response.status === 401) {
                        if (this.props.history !== undefined) { this.props.history.push('/SessionOut') }
                    }
                    else {

                    }
                })
        })
    }
    render() {
        const { ViewQnA, selectedCard, cardDetailsId } = this.state
        const { cardState } = this.props
        return (
            <div>
                    <div className="row" >
                        <div className="col-sm-12">
                            <AuthNavbar />
                        </div>
                        <div className="container" style={{}}>
                            <div className="row">
                                {/* <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                                    <LeftLink />
                                </div> */}
                                <div className="col-sm-12">
                                    <div className="row" style={{ padding: "12px 0px", minHeight: "476px" }}>


                                        <div className="col-sm-12 ml-2" style={{ }}>
                                

                                            <div className="col-sm-12 p-0" style={{ background: "#fff" }}>
                                                <div className="upload-content">

                                                        {ViewQnA &&
                                                            ViewQnA.map((value, Index) =>
                                                                <div className="col-sm-12">
                                                                    <div className="">
                                                                        <div dangerouslySetInnerHTML={{ __html: value }} />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }

                                                    </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WalletTerms);


// WEBPACK FOOTER //
// ./src/components/wallet/walletterms.jsx